/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Description of the performance levels of a rubric
 */
export interface PerformanceLevelDescription {
  [key: string]: string[];
}
